import { render, staticRenderFns } from "./TreasurerFaq.vue?vue&type=template&id=1fa790c2&scoped=true&"
import script from "./TreasurerFaq.vue?vue&type=script&lang=js&"
export * from "./TreasurerFaq.vue?vue&type=script&lang=js&"
import style0 from "./TreasurerFaq.vue?vue&type=style&index=0&id=1fa790c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa790c2",
  null
  
)

export default component.exports